var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChampIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1872 12.6302H14.9296C11.4962 12.6302 8.71289 15.4136 8.71289 18.847V24.1732C8.71289 27.6066 11.4962 30.3899 14.9296 30.3899H25.1872C28.6206 30.3899 31.404 27.6066 31.404 24.1732V18.847C31.404 15.4136 28.6206 12.6302 25.1872 12.6302Z",
    fill: "#A6E9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0891 16.048H15.0303C13.1891 16.048 11.6965 17.5406 11.6965 19.3818V23.6369C11.6965 25.4781 13.1891 26.9707 15.0303 26.9707H25.0891C26.9303 26.9707 28.4229 25.4781 28.4229 23.6369V19.3818C28.4229 17.5406 26.9303 16.048 25.0891 16.048Z",
    fill: "#02A9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.637 12.6302L24.4872 13.3989C24.3948 13.8596 23.9789 14.5821 23.1682 14.5821H17.534C16.7219 14.5821 16.474 14.1326 16.215 13.3989L16.0652 12.6302",
    fill: "#02A9E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1161 21.7747H13.2046V22.6862H14.1161V21.7747Z",
    fill: "#002E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.026 20.8646H14.1145V21.7761H15.026V20.8646Z",
    fill: "#002E6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9364 19.9545H15.0249V20.866H15.9364V19.9545Z",
    fill: "#002E6B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9725 19.9545H16.061V20.866H16.9725V19.9545Z",
    fill: "#002E6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7926 21.7747H17.8811V22.6862H18.7926V21.7747Z",
    fill: "#002E6B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8825 20.8646H16.9709V21.7761H17.8825V20.8646Z",
    fill: "#002E6B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2372 21.7747H21.3257V22.6862H22.2372V21.7747Z",
    fill: "#002E6B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1473 20.8646H22.2358V21.7761H23.1473V20.8646Z",
    fill: "#002E6B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0575 19.9545H23.146V20.866H24.0575V19.9545Z",
    fill: "#002E6B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0936 19.9545H24.1821V20.866H25.0936V19.9545Z",
    fill: "#002E6B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9137 21.7747H26.0022V22.6862H26.9137V21.7747Z",
    fill: "#002E6B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0038 20.8646H25.0923V21.7761H26.0038V20.8646Z",
    fill: "#002E6B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8115 14.6685C35.5784 12.5349 35.6992 10.6252 35.0814 10.4031C34.4636 10.1811 33.341 11.7307 32.5741 13.8644C31.8072 15.998 31.6864 17.9077 32.3042 18.1298C32.922 18.3518 34.0446 16.8022 34.8115 14.6685Z",
    fill: "#E57200"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89586 18.1287C8.51368 17.9066 8.39284 15.997 7.62594 13.8633C6.85904 11.7297 5.7365 10.18 5.11867 10.4021C4.50085 10.6241 4.62169 12.5338 5.38859 14.6675C6.15549 16.8011 7.27803 18.3508 7.89586 18.1287Z",
    fill: "#E57200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4053 18.1679C32.496 18.4339 33.7071 19.463 33.7071 21.5451C33.7071 23.6271 32.3882 24.6016 31.4053 24.8523",
    fill: "#002E6B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71276 18.1679C7.62203 18.4339 6.41089 19.463 6.41089 21.5451C6.41089 23.6271 7.72984 24.6016 8.71276 24.8523",
    fill: "#002E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampIcon);
export default __webpack_public_path__ + "static/media/CHAMPIcon.3a92100901ef2b5925c77555a4c7ccf6.svg";
export { ForwardRef as ReactComponent };